<template>
  <v-card class="card-quote" elevation="0" style="min-height: 100%;">
    <v-card-text>
      <v-row class="px-5 pb-5">
        <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
          <!-- <v-img src="img/icons/quote_life_number.png" width="260" contain></v-img> -->
          <div
            class="d-flex flex-row align-center">
            <v-sheet
              color="title-icon"
              class="d-flex justify-center align-center rounded-circle"
              height="38"
              width="38">
              <v-icon color="title-icon-background" size="20">fas fa-users</v-icon>
            </v-sheet>
            <span
              class="title-foreground--text font-weight-medium ml-2">
              Informe o número de vidas
            </span>
          </div>
        </v-col>

        <v-col cols="1" sm="1" lg="3" class="component-col-header text-center"></v-col>
        <v-col cols="3" lg="2" class="component-col-header py-0 my-0 text-center">
          <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">T</p>
          <p class="py-0 my-0 text-truncate" style="font-size: 10px;">Titulares</p>
        </v-col>
        <v-col cols="3" lg="2" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
          <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">D</p>
          <p class="py-0 my-0 text-truncate" style="font-size: 10px;">Dependentes</p>
        </v-col>
        <v-col cols="3" lg="2" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
          <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">TOTAL</p>
          <p class="py-0 my-0" style="font-size: 10px;"> </p>
        </v-col>
        
        <v-col cols="12">
          <v-row v-for="(item, index) in ageIntervals" :key="index">
            <v-col cols="1" sm="1" lg="3" class="component-col-age text-right">
              {{ item.description }}
            </v-col>
            <v-col cols="3" lg="2" class="component-col-age pr-0 mr-0 py-0 my-0">
              <v-text-field
                :readonly="iReadOnly"
                @keydown="$util.acceptOnlyNumbers"
                :maxlength="6"
                v-model.number="item.holderCount"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3" lg="2" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
              <v-text-field
                :readonly="iReadOnly"
                @keydown="$util.acceptOnlyNumbers"
                :maxlength="6"
                v-model.number="item.dependentCount"
                outlined
                dense
              />
            </v-col>
            <v-col cols="3" lg="2" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
              <v-text-field
                :readonly="iReadOnly"
                v-model="item.total"
                disabled
                outlined
                filled
                dense
              />
            </v-col>
            <v-col cols="2" lg="auto" class="component-col-age text-center"></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapMutations} from "vuex";

export default {
  name: 'juridicalPersonPlanLifeCount',
  data: () => ({
    iReadOnly: false,
    showRequiredFields: false,
    ageIntervals: [
      { description: '', holderCount: null, dependentCount: null, total: null },
    ],
    ageIntervalsTotal: {
      sumHolderCount: null,
      sumDependentCount: null,
      sumTotal: null,
    },
  }),
  watch: {
    ageIntervals: {
      handler(newValue) {
        if(newValue) {
          this.ageIntervalsTotal.sumTotal = 0;
          this.ageIntervalsTotal.sumDependentCount = 0;
          this.ageIntervalsTotal.sumHolderCount = 0;
          this.ageIntervals.forEach(item => {
            const holderCount = item.holderCount && parseInt(item.holderCount) > 0 ? parseInt(item.holderCount): 0;
            const dependentCount = item.dependentCount && parseInt(item.dependentCount) > 0 ? parseInt(item.dependentCount) : 0;
            item.total = ((holderCount + dependentCount) > 0) ? holderCount + dependentCount : null;
            
            if(item.total && parseInt(item.total) > 0) {
              this.ageIntervalsTotal.sumTotal = this.ageIntervalsTotal.sumTotal + parseInt(item.total);
            }

            if(item.dependentCount && parseInt(item.dependentCount) > 0) {
              this.ageIntervalsTotal.sumDependentCount = this.ageIntervalsTotal.sumDependentCount + parseInt(item.dependentCount);
            }

            if(item.holderCount && parseInt(item.holderCount) > 0) {
              this.ageIntervalsTotal.sumHolderCount = this.ageIntervalsTotal.sumHolderCount + parseInt(item.holderCount);
            }
          });
          
          if(this.ageIntervalsTotal.sumTotal === 0) {
            this.ageIntervalsTotal.sumTotal = null;
          }

          if(this.ageIntervalsTotal.sumDependentCount === 0) {
            this.ageIntervalsTotal.sumDependentCount = null;
          }

          if(this.ageIntervalsTotal.sumHolderCount === 0) {
            this.ageIntervalsTotal.sumHolderCount = null;
          }
        }
        this.updateAgeInterval();
        this.updateAgeIntervalTotal();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations(['showmsg']),
    ...mapActions(['setAgeIntervalsObj', 'setAgeIntervalsTotalObj']),
    clearFieds() {
      this.setAgeIntervalsObj(JSON.parse(JSON.stringify([])));

      this.ageIntervals.forEach(item => {
        item.holderCount = null;
        item.dependentCount = null;
        item.total = null;
      });
    },
    updateAgeInterval() {
      this.setAgeIntervalsObj(JSON.parse(JSON.stringify(this.ageIntervals)));
    },
    updateAgeIntervalTotal() {
      this.setAgeIntervalsTotalObj(JSON.parse(JSON.stringify(this.ageIntervalsTotal)));
    },
    reloadDataFromSessionStorage() {
      const key = 'quoteDataObj';
      if (sessionStorage.getItem(key)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(key)));
        this.ageIntervals = quoteData && quoteData.ageIntervalsObj && quoteData.ageIntervalsObj.length ? quoteData.ageIntervalsObj : this.ageIntervals;
        this.ageIntervalsTotal = quoteData && quoteData.ageIntervalsTotalObj ? quoteData.ageIntervalsTotalObj : this.ageIntervalsTotal;
      }
    }
  },
  created() {
    this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');
    this.reloadDataFromSessionStorage();
  },
};
</script>

<style scoped>

.component-col-age {
  height: 45px !important;
}

.component-col-header {
  height: 25px !important;
  color: var(--v-foreground-base);
  font-weight: bold;
}

</style>
